module.exports = __webpack_public_path__ + "static/media/poster-selection.17fa9e69.svg";